import { render, staticRenderFns } from "./NameColor.vue?vue&type=template&id=337a0ec1"
import script from "./NameColor.vue?vue&type=script&lang=js"
export * from "./NameColor.vue?vue&type=script&lang=js"
import style0 from "./NameColor.vue?vue&type=style&index=0&id=337a0ec1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports